import React, { Suspense } from 'react';

import * as Appointment from './appointment';
import Delete from './exclude';
import Success from './success';
import * as User from './user';

import ProfessionalsOnDutySidesheet from '~/presentation/pages/Duty/Sidesheet';
import CreateNewLayOver from '../createNewLayOver';
import AuditRecordDrawer from '../drawers/AuditRecord';
import ModalAcceptTermsWaitingRoom from '../modalAcceptTermsWaitingRoom';
import ModalExpiredFremium from '../modalExpiredFremium/ModalExpiredFremium';
import ModalIsProfessionalAvailable from '../modalIsProfessionalAvailable';
import ModalLeaveInterconsult from '../modalLeaveInterconsult';
import ModalNewAvailableInterconsult from '../modalNewAvailableInterconsult';
import ModalReadyWaitingRoom from '../modalReadyWaitingRoom';
import ModalRequestConsultation from '../modalRequestConsultation';
import ErrorMessage from './error';
import { ownProps } from './interface';
import { ConnectComponent } from './mapper/mapperMessage';
import EditShift from '../editShift';
import InstantAppointmentModal from '../instantAppointmentModal';
import InstantAppointmentSuccessModal from '../InstantAppointmentSuccessModal';
import ModalCancelInterconsult from '../modalCancelInterconsult';
import ModalFinishInterconsult from '../modalFinishInterconsult';
import ModalEnterInterconsult from '../modalEnterInterconsult';
import ModalConsultationRequest from '../modalConsultationRequest';
import ModalUpdateRequestInProgress from '../modalUpdateRequestInProgress';
import ModalCancelReportLaudo from '../modalLaudo';
import ModalSoapAi from '../modalSoapAi';
import {
  ModalCancelReport,
  ModalEvaluateReport,
  ModalSignReport,
  ModalSketchReport,
  ModalSketchReporting,
  ModalSuccessReport,
} from '../modalsReport';
import { SupportDocsModal } from '../supportDocsModal';
import CancelMedicalOpinion from '../modals/teleconsultation/cancelMedicalOpinion';
import StartInterconsult from '../modals/teleconsultation/startInterconsult';
import EvaluateMedicalOpinion from '../modals/teleconsultation/evaluateMedicalOpinion';
import SignMedicalOpinion from '../modals/teleconsultation/signMedicalOpinion';
import { TwoButtonModal } from '../TwoButtonModal';
import { EmergencyConsultation } from '../EmergencyConsultation';
import { AvailabilityModal } from '../AdmScaleModals/AvailabilityModal';
import { AddProfessionalToScaleModal } from '../AdmScaleModals/AddProfessionalToScaleModal';
import ModalRequestSuccess from '../modalsReport/ModalRequestSuccess';
import { ModalWelcomeDuty } from '../modalWelcomeDuty';
import ModalAvailability from './appointment/Availability';

const Notifications: React.FC<ownProps> = ({
  children,
  message,
}): JSX.Element => {
  return (
    <Suspense fallback={<div>loading...</div>}>
      <Appointment.AppointmentReady message={message} />
      <Appointment.AppointmentSOAP message={message} />
      <Appointment.ConfirmCancellation message={message} />
      <Appointment.ScheduleExclude message={message} />
      <Appointment.SuccessfullyCreated message={message} />
      <Appointment.TermsOfUse message={message} />
      <Appointment.EditConsultCopyLink message={message} />
      <Appointment.InviteExternalProfessionals message={message} />
      <User.UserRegisterSuccess message={message} />
      <User.WaitingMessage message={message} />
      <User.WarningMessage message={message} />
      <User.UserLeaveSpecialty message={message} />
      <User.UserChangeRole message={message} />
      <User.UserAlreadyExistsOnSector message={message} />
      <User.UserDataFulfill message={message} />
      <User.UserEditDataError message={message} />
      <Delete message={message} />
      <Success message={message} />
      <ModalExpiredFremium message={message} />
      <ErrorMessage message={message} />
      <AuditRecordDrawer message={message} />
      <ProfessionalsOnDutySidesheet message={message} />
      <ModalRequestConsultation message={message} />
      <ModalNewAvailableInterconsult message={message} />
      <ModalIsProfessionalAvailable message={message} />
      <ModalLeaveInterconsult message={message} />
      <ModalAcceptTermsWaitingRoom message={message} />
      <ModalReadyWaitingRoom message={message} />
      <CreateNewLayOver message={message} />
      <EditShift message={message} />
      <InstantAppointmentModal message={message} />
      <InstantAppointmentSuccessModal message={message} />
      <ModalCancelInterconsult message={message} />
      <ModalFinishInterconsult message={message} />
      <ModalEnterInterconsult message={message} />
      <ModalConsultationRequest message={message} />
      <ModalUpdateRequestInProgress message={message} />
      <ModalCancelReportLaudo message={message} />
      <ModalCancelReport message={message} />
      <ModalSketchReport message={message} />
      <ModalSuccessReport message={message} />
      <ModalSketchReporting message={message} />
      <ModalEvaluateReport message={message} />
      <ModalSignReport message={message} />
      <ModalSoapAi message={message} />
      <SupportDocsModal message={message} />
      <CancelMedicalOpinion message={message} />
      <StartInterconsult message={message} />
      <EvaluateMedicalOpinion message={message} />
      <SignMedicalOpinion message={message} />
      <TwoButtonModal message={message} />
      <EmergencyConsultation message={message} />
      <AvailabilityModal message={message} />
      <AddProfessionalToScaleModal message={message} />
      <ModalRequestSuccess message={message} />
      <ModalWelcomeDuty message={message} />
      <ModalAvailability message={message} />
      {children}
    </Suspense>
  );
};

export default ConnectComponent(Notifications);
